import loading from "@/assets/images/LoadingPPS.gif"

export default function LoadingPPS(){
    return <div style={{ boxSizing: "border-box",  width: "100vw", height: "100vh",backgroundColor: "#FFFFFF60", display: "flex", justifyContent: "center", alignItems: "center"}} >
    <img src={loading} width={"30%"} />
    </div>
}